import InitialReviewFollowUpPage from "../../shared/initialReviewFollowUp/InitialReviewFollowUpPage";

const MODIFY_PATH = "/SLN/Management/CheckNewRequest";

export default function ManagementInitialReviewFollowUpPage() {
  return <InitialReviewFollowUpPage modifyPath={MODIFY_PATH} />;
}
